<!--
  a11y: top close (X) button added so this popup matches the audit pattern
  ("every popup must have a close button at the top that receives initial
  focus on open"). [focusInitial]=true and FIRST in DOM order.
-->
<div class="flex flex-col gap-2">
  <div class="!flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>

  <div class="relative bg-gray-300 border border-solid border-gray py-2 px-10 rounded-lg">
    <mot-button [cdkCopyToClipboard]="link" (cdkCopyToClipboardCopied)="onLinkCopied($event)"
      matType="icon" class="absolute right-1 top-1" icon="arrow-up-right" />

    <code class="break-words">{{ link }}</code>
  </div>
</div>